var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-dashboard"},[_c('h2',[_vm._v("仪表盘")]),_vm._v(" "),_c('p',{staticClass:"welcome"},[_vm._v("欢迎，"+_vm._s(_vm.auth.user ? _vm.auth.user.name : '管理员')+"。")]),_vm._v(" "),_c('el-alert',{attrs:{"type":"info","closable":false,"title":"管理端框架已就绪","description":"具体功能模块后续逐步接入，左侧菜单可直接追加。"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-028e8d42","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/admin/views/Dashboard.vue
// module id = 195
// module chunks = 0